import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import Facebook from "elevate-ui-icons/Facebook";
import Twitter from "elevate-ui-icons/Twitter";
import LinkedIn from "elevate-ui-icons/LinkedIn";

type Props = {
  classes: Object,
  className: string,
  post: Object,
  site: Object,
};

const encodeString = (str) => {
  return encodeURIComponent(str)
    .replace(/!/g, "%21")
    .replace(/'/g, "%27")
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/\*/g, "%2A")
    .replace(/\+/g, "%2B"); // explicitly encoding the '+' character
};

const generateTweetUrl = (title, domain, postId) => {
  const encodedTitle = encodeString(title);
  const encodedUrl = encodeString(`https://${domain}/blog/post/${postId}`);
  return `https://twitter.com/intent/tweet?text=${encodedTitle}%20${encodedUrl}`;
};

const SocialLinks = ({ classes, className, post, site }: Props) => {
  const tweetUrl = generateTweetUrl(
    post.title,
    site.primaryDomain.domain,
    post.id
  );

  return (
    <div className={classNames(classes.root, className)}>
      <a
        className={classNames(classes.icon, classes.facebook)}
        href={`https://www.facebook.com/sharer/sharer.php?u=${
          site.primaryDomain.domain
        }/blog/post/${post.id}&title=${post.title}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <Facebook size={32} />
      </a>
      <a
        className={classNames(classes.icon, classes.twitter)}
        href={tweetUrl}
        target="_blank"
        rel="noreferrer noopener"
      >
        <Twitter size={32} />
      </a>
      <a
        className={classNames(classes.icon, classes.linkedin)}
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${
          site.primaryDomain.domain
        }/blog/post/${post.id}&title=${post.title}`}
        target="_blank"
        rel="noreferrer noopener"
      >
        <LinkedIn size={32} />
      </a>
    </div>
  );
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
  },
  icon: {
    margin: "0 2px",

    "&:hover": {
      color: "inherit",
      opacity: "0.6",
    },
  },
  facebook: {
    color: theme.colors.facebook || "#000",
  },
  twitter: {
    color: theme.colors.twitter || "#000",
  },
  linkedin: {
    color: theme.colors.linkedin || "#000",
  },
  google: {
    color: theme.colors.google || "#000",
  },
}))(SocialLinks);
